import { clearErrorMessages, formatMoney, isFormValid, sendRequest, showAlert, showErrorMessages } from "../../../functions";
import PhoneInput from "../../formio/components/phone-input";
import { calculateTotalAmount, restyleFormButtons, setBackendValidationRules } from "../../formio/functions";


$(window).on('load', function() {
    $('#adherentCode').prop('disabled', false)
})

$(document).ready(() => {
    let adherent;
    let timer;

    // Disable submiting if on preview
    if (window.location.pathname.match("preview")) {
        Formio.Components.components.button.prototype.onClick = function (event) {
            event.preventDefault();
        };
    }

    Formio.use({
        components: {
            phoneinput: PhoneInput,
        },
    });


    $('[name="payment_type"]').on('change', function () {
        if (this.value == 'virement') {
            $('#form').show(500);
            $('#cibPaymentForm').hide(500);

        } else {
            $('#cibPaymentForm').show(500);
            $('#form').hide(500);
        }
    })

    $('#adherentCode').on('input keydown', function () {
        let code = $(this).val().trim();
        if (code.length >= 6 && $('#adherentCode').prop('readonly') == false) {
            // On each input type, clear old timer
            clearTimeout(timer);
            timer = setTimeout(() => {
                checkAdherentExists(code);
            }, 1000)
        }
    })


    function loadForm(ticketKey, selectedPriceId) {

        Formio.createForm(document.getElementById("form"), {
            components: JSON.parse(formComponents)
        }).then((form) => {
            restyleFormButtons();
            $("#form").attr('hidden', false);


            form.on("submit", function (submission) {
                if (! validateTicket()) {
                    return;
                }

                let formData = {};
                let validationRules = setBackendValidationRules(form);
                formData = Object.assign(formData, submission.data);
                formData.organization_id = organizationId;
                formData.form_type = formType;
                formData.rules = JSON.stringify(validationRules);

                // Add ticket data to formData
                formData[$(".ticket").attr('name')] = $(".ticket").val();


                sendRequest(formSubmitUrl, "POST", formData, true)
                .done((response) => {
                    window.location.href = response.data.redirectUrl
                })
                .fail((response) => showErrorMessages(response))
                .always((response) => {
                    setTimeout(() => {
                        $("#inProgressModal").modal("hide");
                    }, 300);
                });
            });
        });
    }

    $('#cibPaymentForm').on('submit', function(e) {
        e.preventDefault();
        if (! isFormValid('cibPaymentForm')) {
            return;
        }

        if (! validateTicket()) {
            return;
        }

        if ($("[name='g-recaptcha-response']").val() == '') { // validate captcha
            showAlert('error', 'Veuillez cocher la case "Je ne suis pas un robot".');
            return;
        }

        $('#authModal').modal('show');
    });


    function processCibCheckout(adhernetCode) {
        let formData = $('#cibPaymentForm').serializeArray();
        formData.push({
            name: $(".ticket").attr('name'),
            value: $(".ticket").val()
        });

        return sendRequest(
            route('frontend.organization.adherents.cibPayment.processCheckout', [organizationSlug, adhernetCode]),
            'POST',
            formData,
            true
        )
        .done((response) => {
            window.location.href = response.data.redirectUrl
        })
        .fail((response) => showErrorMessages(response))
    }

    window.processCibCheckout = processCibCheckout;


    function validateTicket() {
        let result = true;
        const $ticketElem = $(".ticket");

        if ($ticketElem.is('select') && !$ticketElem.val()) {
            result = false;
        }

        if ($ticketElem.is('input[type="radio"]') && !$ticketElem.is(':checked')) {
            result = false;
        }

        if ($ticketElem.is('input[type="checkbox"]') && !$ticketElem.is(':checked')) {
            result = false;
        }

        if (! result) {
            showAlert('error', 'Veuillez chooisir un billet');
            return false;
        }

        return true;
    }


    function checkAdherentExists(code) {
        Functions.sendRequest(route('frontend.organization.adherents.checkExistsForPayement', organizationSlug),
            "POST", {
            code: code
        })
        .done((response) => {
            adherent = response.data.adherent;
            calculateTotalAmount();

            if (response.data.currentOrder) {
                selectReservedTickets(response.data.currentOrder, "#subscriptionContainer");
                calculateTotalAmount();
            }

            $('[data-ticket-name]').on('change', function () {
                calculateTotalAmount();
            });

            loadForm(response.ticket_key, response.selected_price_id);
            clearErrorMessages();
            $('#adherentCode')
            .prop('readonly', true)
            .removeClass('is-invalid')
            .addClass('is-valid');

            $('#formContainer').show(500);
        })
        .fail((response) => {
            showErrorMessages(response);
            $('#formContainer').hide(500);
            $('#adherentCode')
                .prop('readonly', false)
                .addClass('is-invalid');
        });
    }

    function selectReservedTickets(order) {

        let ticketsWithPrice = order.tickets_with_price;

        $("#subscriptionContainer")
        .find("[data-ticket-name]")
        .each(function () {
            let currentTicketP = ticketsWithPrice.find(
                (ticketP) => ticketP.ticket_name == $(this).data('ticket-name')
            );

            if (currentTicketP) {
                const currentPriceLabel = currentTicketP.price_label+ " : " +currentTicketP.pivot.price_amount+ " DA";

                if (this.localName == "select") {
                    $(this).val(currentTicketP.price_id);

                    // Setting the ordered price
                    $(this).find(':selected')
                    .attr('data-amount', currentTicketP.pivot.price_amount)
                    .text(currentPriceLabel);


                }

                if (this.type == "checkbox") {
                    $(this).prop("checked", true)
                    .attr('data-amount', currentTicketP.pivot.price_amount)
                    .siblings("label")
                    .text(currentPriceLabel) // Setting the ordered price

                }

                if ($(this).data('type') == "radio") {
                    $(this).children('input').each(function () {
                        if ($(this).val() == currentTicketP.price_id) {
                            $(this).prop("checked", true)
                            .attr('data-amount', currentTicketP.pivot.price_amount)
                            .siblings("label")
                            .text(currentPriceLabel) // Setting the ordered price;
                        }
                    });
                }
            }
        });
    }

    function calculateTotalAmount() {
        let totalAmount = 0;

        $("#subscriptionContainer")
        .find("[data-ticket-name]")
        .each(function () {
            let currentPrice;

            if (this.localName == "select") {
                currentPrice = $(this).find(':selected');
            }

            if (this.type == "checkbox" && $(this).prop("checked")) {
                currentPrice = $(this);
            }

            if ($(this).data('type') == "radio") {
                currentPrice = $(this).find('input:checked');
            }

            if (currentPrice != undefined && currentPrice.length) {
                totalAmount += parseInt($(currentPrice).data('amount'));
            }
        });

        $('#orderTotal #value').text(formatMoney(totalAmount));
    }



    $(document).ajaxSend(function (event, xhr, settings) {
        // Append the adherent code to form data
        if (settings.url.includes('register')) {
            settings.data += "&" + encodeURIComponent('code') + "=" + encodeURIComponent($("#adherentCode").val());
        }
    });


});
